import React from 'react'
import { Button, Form } from 'react-bootstrap';
import { ColumnDescription } from 'react-bootstrap-table-next';
import { FaEdit, FaUsers, FaUserLock } from 'react-icons/fa/index';

import Navigation from '../../components/navigation/Navigation'
import Table from '../../components/Table';
import Modal from '../../components/Modal';

import { Administration } from '../../lib/dataAccess/DataAccess';
import { IPermissionRole } from '../../lib/types/types';
import { preventKeypressEnter } from '../../lib/utilities';
import { right } from '@popperjs/core';

interface Props { role: string };
interface State {
    error: string | null,
    isLoading: boolean,
    permissionRoles: IPermissionRole[],
    showModal: boolean
};

export default class PermissionsPage extends React.Component<Props, State>
{
    constructor(props: Props) 
    {
        super(props)

        this.addNewRole = this.addNewRole.bind(this);
        
        this.state = {
            error: null,
            isLoading: true,
            permissionRoles: [],
            showModal: false
        }
    }

    componentDidMount() {
        this.getPermissionRoles();
    }

    async getPermissionRoles() {
        try {
            const permissionRoles = await Administration.PermissionRole.getPermissionRoles();

            this.setState({permissionRoles, isLoading: false});
        }
        catch (error) {
            this.setState({error: error, isLoading: false});
        }
    }

    async addNewRole(e: React.ChangeEvent<HTMLFormElement>) {
        e.preventDefault(); 
        e.stopPropagation();

        const name = (e.currentTarget[0] as HTMLInputElement).value;
        const description = (e.currentTarget[1] as HTMLTextAreaElement).value

        const newRole: IPermissionRole = { id: -1, name, description, system: false, permissions: [], userRole: [] };

        Administration.PermissionRole.addPermissionRole(newRole)
            .then((permissionRole: IPermissionRole) => {
                window.location.href = `/admin/role/${permissionRole.id}/edit`;
                //window.location.replace(`/admin/role/${permissionRole.id}/edit`);
                //this.setState({ permissionRoles: [...this.state.permissionRoles, permissionRole], showModal: false});
            }).catch(error => {
                console.error(error);
            });
    }

    render() {
        const { error, isLoading, permissionRoles, showModal } = this.state
        
        const columns : ColumnDescription<any, any>[] = [{
                dataField: 'id',
                text: 'ID',
                hidden: true
            }, {
                dataField: 'system',
                text: '',
                sort: true,
                headerStyle: { width: '3rem', textAlign: 'center' },
                formatter: (cell: boolean, _) => {
                    return (<div style={{ color: (cell ? 'white' : 'black') }}>
                            {cell ? <FaUserLock title="Administrerad roll" size={24} /> : <FaUsers title="Migrerad systemroll" size={24}/>}
                        </div>);
                }
            }, {
                dataField: 'name',
                text: 'Rättighetsgrupp',
                sort: true
            }, {
                dataField: 'description',
                text: 'Beskrivning'
            }, {
                dataField: 'edit',
                isDummyField: true,
                text: 'Redigera',
                headerStyle: { width: '6rem', textAlign: 'center' },
                formatter: (_, row: IPermissionRole) => {
                    return (<div style={{ textAlign: 'center' }}>
                        <a style={{ cursor: 'pointer', color: (row.system ? 'white' : 'black') }} href={`/admin/role/${row.id}/edit`}>
                            <FaEdit size={24}/>
                        </a>
                    </div>);
                }
            }
        ];

        const menuField = [(<div style={{float:'right'}}>
                <Button style={{fontSize: '1.1rem', marginLeft: '1rem'}} onClick={() => this.setState({showModal: true})}>
                    Lägg till roll
                </Button>
            </div>)];

        return (
            <div className="render-adminPage">
                <Navigation role={ this.props.role } />
                <Modal title="Lägg till ny Rättighetsgrupp" show={showModal} onHide={() => this.setState({showModal: false})}>
                    <Form onSubmit={this.addNewRole}>
                        <Form.Group controlId="submitRole-name">
                            <Form.Label style={{fontSize:'1.25rem', fontWeight: 'bold'}}>Namn:</Form.Label>
                            <Form.Control type="text" required onKeyDown={preventKeypressEnter}/>
                        </Form.Group>
                        <Form.Group controlId="submitRole-description">
                            <Form.Label style={{fontSize:'1.25rem', fontWeight: 'bold'}}>Beskrivning:</Form.Label>
                            <Form.Control as="textarea" rows={8}/>
                        </Form.Group>
                        <Button type="submit">
                            Skapa Rättighetsgrupp
                        </Button>
                    </Form>
                </Modal>
                <div className="junit-container" style={{height:'100%'}}>
                    {/*<EditAccessGroup show={showEditPanel} accessGroupId={editId}/>*/}
                    <br/>
                    <Table keyField={'id'} 
                        columns={columns} 
                        data={permissionRoles} 
                        loading={isLoading} 
                        menuField={menuField}
                        pageSize={20}
                        bsTableProps={{
                            rowStyle: (row: any, rowIndex: number) => {
                                if(row.system) {
                                    return { backgroundColor: '#7D7D7D', color: 'white' }
                                }
                                else { return {} }
                            }
                        }}                        
                    />
                </div>
            </div>
        )
    }
}
